export enum OnlineDevicesView {
	Devices = 'DEVICES',
	Rooms = 'ROOMS',
	Connections = 'CONNECTIONS'
}
